import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { ITraderKey, ISearchCondition } from '../dto/TraderInfo';


@Module({ dynamic: true, store, name: 'traderInfo', namespaced: true })
class TraderInfo extends VuexModule {

  /**
   * @state
   * 業者情報キー(許可番号)
   * 検索画面から業者情報画面に受け渡し用
   */
  traderKey: ITraderKey = {
    dataSearchType: '',
    licenseNo: '',
  };

  /**
   * @state
   * 検索条件
   * 検索画面に戻った際の検索条件
   */
  searchCondition: any = [];

  /**
   * @state
   * 再検索フラグ
   */
  searchFlag: boolean = false;

  /**
   * @Getter
   * 業者情報キー
   */
  get GET_TRADER_KEY() {
    return this.traderKey;
  }

  /**
   * @Getter
   * 業者情報取得用のパス
   */
  get GET_TRADER_PATH() {
    return `/${this.traderKey.dataSearchType}/${this.traderKey.licenseNo}`;
  }

  /**
   * @Getter
   * 検索条件
   */
  get GET_SEARCH_CONDITION() {
    return this.searchCondition;
  }

  /**
   * @Getter
   * 再検索フラグ
   */
  get GET_SEARCH_FLAG() {
    return this.searchFlag;
  }

  /**
   * @Action
   * 再検索フラグ変更
   * 再検索フラグをtrueにする
   */
  @Action({})
  public changeSearchFlagOn() {
    this.SEARCH_FLAG_ON();
  }

  /**
   * @Action
   * 再検索フラグ変更
   * 再検索フラグをfalseにする
   */
  @Action({})
  public changeSearchFlagOff() {
    this.SEARCH_FLAG_OFF();
  }

  /**
   * @Action
   * 業者情報キー格納
   * @param param ITraderKey
   */
  @Action({})
  public setTraderKey(param: ITraderKey) {
    this.SET_TRADER_KEY(param);
  }

  /**
   * @Action
   * 検索条件格納
   * @param param ISearchCondition
   */
  @Action({})
  public setSearchCondtion(param: ISearchCondition) {
    this.SET_SEARCH_CONDITION(param);
  }

  /**
   * @Action
   * モジュールリセット
   */
  @Action({})
  public moduleReset() {
    this.MODULE_RESET();
  }

  @Mutation
  private SET_TRADER_KEY(param: ITraderKey) {
    this.traderKey = param;
  }

  @Mutation
  private SET_SEARCH_CONDITION(param: ISearchCondition) {
    this.searchCondition = param;
  }

  @Mutation
  private SEARCH_FLAG_ON() {
    this.searchFlag = true;
  }

  @Mutation
  private SEARCH_FLAG_OFF() {
    this.searchFlag = false;
  }

  @Mutation
  private MODULE_RESET() {

    this.traderKey = {
      dataSearchType: '',
      licenseNo: '',
    };

    this.searchCondition = [];

    this.searchFlag = false;
  }
}

export const traderInfoModule = getModule(TraderInfo);
